<template>
  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Manage Document</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                    <li class="breadcrumb-item active">Performance Management</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Notification Toast -->
          <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 11">
            <div id="notification-toast" class="toast" :class="{'show': message}" role="alert" aria-live="assertive" aria-atomic="true">
              <div class="toast-header" :class="message && message.includes('success') ? 'bg-success text-white' : 'bg-danger text-white'">
                <strong class="me-auto">{{ message && message.includes('success') ? 'Success' : 'Error' }}</strong>
                <button type="button" class="btn-close" @click="message = ''" aria-label="Close"></button>
              </div>
              <div class="toast-body">
                {{ message }}
              </div>
            </div>
          </div>

          <!-- stats cards -->
          <div class="row" v-if="statisticsEnabled">
            <!-- Total Documents -->
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Documents</p>
                      <h5 class="mb-0">{{ statistics.totalDocuments }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-info rounded-circle text-white font-size-20">
                        <i class="bx bxs-file"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Recent Uploads -->
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Recent Uploads</p>
                      <h5 class="mb-0">{{ statistics.recentUploads }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-success rounded-circle text-white font-size-20">
                        <i class="bx bx-upload"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Document Categories -->
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Categories</p>
                      <h5 class="mb-0">{{ statistics.categories }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-primary rounded-circle text-white font-size-20">
                        <i class="bx bx-category"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Document Types -->
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Departments</p>
                      <h5 class="mb-0">{{ departments.length }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                        <i class="bx bx-building"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end of stats -->
          <div class="row">
            <div class="col-12">
              <div class="card">

                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">

                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input type="text" class="form-control bg-light border-light rounded"
                                 placeholder="Search..." v-model="searchKeyword" @input="handleSearch">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex">
                      <div class="d-flex align-items-center me-3 pe-3">
                        <div>
                          <div class="float-end d-flex ">
                            <div class="input-group fw-semibold text-uppercase me-3">
                              <label class="input-group-text text-uppercase">Department</label>
                              <select class="form-select" style="width: 200px;" v-model="selectedDepartment" @change="handleDepartmentChange">
                                <option value="">All Departments</option>
                                <option v-for="department in departments" :key="department.id" :value="department.id">
                                  {{ department.departmentName }}
                                </option>
                              </select>
                            </div>

                            <!-- Category Filter -->
                            <div class="input-group fw-semibold text-uppercase me-3">
                              <label class="input-group-text text-uppercase">Category</label>
                              <select class="form-select" style="width: 180px;" v-model="selectedCategory" @change="handleCategoryChange">
                                <option value="">All Categories</option>
                                <option value="Policy">Policy</option>
                                <option value="Procedure">Procedure</option>
                                <option value="Form">Form</option>
                                <option value="Report">Report</option>
                                <option value="Manual">Manual</option>
                                <option value="Other">Other</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button @click="exportReport()" type="button" class="btn btn-primary dropdown-toggle option-selector me-3 text-capitalize">
                        <i class="bx bxs-download "></i> <span class="pl-1 d-md-inline">Download Report</span>
                      </button>

                      <!-- Add Document Button -->
                      <button data-bs-toggle="modal" data-bs-target="#modal-document" type="button" class="btn btn-success dropdown-toggle option-selector me-3 text-capitalize">
                        <i class="bx bx-plus"></i> <span class="pl-1 d-md-inline">Add Document</span>
                      </button>
                    </div>
                  </div>
                  <div class="btn-toolbar p-3 align-items-center d-none animated delete-tool-bar" role="toolbar">
                    <button type="button" data-bs-toggle="modal" data-bs-target=".download-modal" class="btn btn-primary waves-effect btn-label waves-light me-3"><i class="mdi mdi-printer label-icon"></i> Print Selected Invoices</button>
                  </div>
                </div>

                <div class="card-body">
                  <div v-if="isLoading" class="text-center my-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  <div v-else class="table-responsive">
                    <table class="table align-middle table-hover contacts-table table-striped text-nowrap" id="datatable-buttons">
                      <thead class="table-light">
                      <tr class="table-dark">
                        <th>#</th>
                        <th scope="col">Document Name</th>
                        <th scope="col">Description</th>
                        <th scope="col">Department</th>
                        <th scope="col">Category</th>
                        <th scope="col">Upload Date</th>
                        <th scope="col">Views</th>
                        <th scope="col">Action</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(document, index) in documents" :key="document.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ document.name }}</td>
                        <td>{{ document.description }}</td>
                        <td>{{ document.departmentName || 'General' }}</td>
                        <td>
                            <span class="badge rounded-pill" :class="{
                              'bg-success': document.category === 'Policy',
                              'bg-primary': document.category === 'Procedure',
                              'bg-info': document.category === 'Form',
                              'bg-warning': document.category === 'Report',
                              'bg-secondary': document.category === 'Manual',
                              'bg-dark': document.category === 'Other' || !document.category
                            }">
                              {{ document.category || 'Uncategorized' }}
                            </span>
                        </td>
                        <td>{{ formatDate(document.createdAt) }}</td>
                        <td>
                          <span class="badge bg-light text-dark">{{ document.views || 0 }}</span>
                        </td>
                        <td>
                          <button style="margin-right: 5px" class="btn btn-sm btn-success" @click="editDocument(document)" data-bs-toggle="modal" data-bs-target="#editDocumentModal">Edit</button>
                          <button style="margin-right: 5px" @click="viewDocument(document)" class="btn btn-sm btn-primary">View</button>
                          <button style="margin-right: 5px" class="btn btn-sm btn-danger" @click="confirmDeleteDocument(document)">Delete</button>
                        </td>
                      </tr>
                      <tr v-if="documents.length === 0">
                        <td colspan="8" class="text-center">No documents found</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>

          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>

      <!-- Add Document Modal -->
      <!-- Improved Add Document Modal -->
      <div class="modal fade" id="modal-document" tabindex="-1" aria-labelledby="modal-document-label" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-light">
              <h5 class="modal-title" id="modal-document-label">
                <i class="bx bx-plus-circle me-1 text-success"></i>
                Add New Document
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <form id="document-form" @submit.prevent="submitDocument" class="needs-validation" novalidate>
                <div class="row mb-3">
                  <div class="col-12">
                    <label for="document-name" class="form-label fw-bold">Document Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="document-name" v-model="documentForm.name"
                           placeholder="Enter document name" required>
                    <div class="form-text text-muted">Provide a descriptive name for easy identification</div>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-12">
                    <label for="document-description" class="form-label fw-bold">Description</label>
                    <textarea class="form-control" id="document-description" v-model="documentForm.description"
                              rows="3" placeholder="Enter document description"></textarea>
                    <div class="form-text text-muted">Brief description of the document's purpose</div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-md-6 mb-3 mb-md-0">
                    <label for="document-department" class="form-label fw-bold">Department</label>
                    <select class="form-select" id="document-department" v-model="documentForm.departmentId">
                      <option value="">General Document</option>
                      <option v-for="department in departments" :key="department.id" :value="department.id">
                        {{ department.departmentName }}
                      </option>
                    </select>
                    <div class="form-text text-muted">Department this document belongs to</div>
                  </div>

                  <div class="col-md-6">
                    <label for="document-category" class="form-label fw-bold">Category <span class="text-danger">*</span></label>
                    <select class="form-select" id="document-category" v-model="documentForm.category" required>
                      <option value="">Select Category</option>
                      <option value="Policy">Policy</option>
                      <option value="Procedure">Procedure</option>
                      <option value="Form">Form</option>
                      <option value="Report">Report</option>
                      <option value="Manual">Manual</option>
                      <option value="Other">Other</option>
                    </select>
                    <div class="form-text text-muted">Type of document being uploaded</div>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-12">
                    <label for="document-file" class="form-label fw-bold">Upload Document <span class="text-danger">*</span></label>
                    <div class="input-group">
                      <input type="file" class="form-control" id="document-file" @change="handleFileUpload"
                             accept="application/pdf" required>
                      <label class="input-group-text" for="document-file">
                        <i class="bx bx-upload"></i>
                      </label>
                    </div>
                    <div class="form-text text-muted">
                     Accepted formats: PDF Only
                    </div>
                    <div v-if="documentForm.file" class="mt-2">
                <span class="badge bg-success">
                  <i class="bx bx-check me-1"></i>
                  {{ documentForm.file.name }} ({{ formatFileSize(documentForm.file.size) }})
                </span>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="modal-footer bg-light">
              <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
                <i class="bx bx-x me-1"></i> Cancel
              </button>
              <button type="submit" class="btn btn-success" form="document-form" :disabled="isSubmitting">
                <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                <i v-else class="bx bx-save me-1"></i>
                Save Document
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Edit Document Modal -->
      <div class="modal fade" id="editDocumentModal" tabindex="-1" aria-labelledby="editDocumentLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="editDocumentLabel">Edit Document</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <form id="edit-document-form" @submit.prevent="updateDocument">
                <div class="mb-3">
                  <label for="edit-document-name" class="form-label">Document Name</label>
                  <input type="text" class="form-control" id="edit-document-name" v-model="editDocumentForm.name" placeholder="Enter document name" required>
                </div>
                <div class="mb-3">
                  <label for="edit-document-description" class="form-label">Description</label>
                  <textarea class="form-control" id="edit-document-description" v-model="editDocumentForm.description" placeholder="Enter document description" required></textarea>
                </div>
                <div class="mb-3">
                  <label for="edit-document-department" class="form-label">Department</label>
                  <select class="form-select" id="edit-document-department" v-model="editDocumentForm.departmentId">
                    <option value="">General Document</option>
                    <option v-for="department in departments" :key="department.id" :value="department.id">
                      {{ department.departmentName }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label for="edit-document-category" class="form-label">Category</label>
                  <select class="form-select" id="edit-document-category" v-model="editDocumentForm.category">
                    <option value="">Select Category</option>
                    <option value="Policy">Policy</option>
                    <option value="Procedure">Procedure</option>
                    <option value="Form">Form</option>
                    <option value="Report">Report</option>
                    <option value="Manual">Manual</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div class="mb-3">
                  <label for="edit-document-file" class="form-label">Upload New File (Optional)</label>
                  <input type="file" class="form-control" id="edit-document-file" @change="handleEditFileUpload">
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="submit" class="btn btn-primary" form="edit-document-form" :disabled="isSubmitting">
                <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Delete Document Confirmation Modal -->
      <div class="modal fade" id="deleteDocumentModal" tabindex="-1" aria-labelledby="deleteDocumentLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="deleteDocumentLabel">Confirm Delete</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p>Are you sure you want to delete the document "{{ deleteDocumentName }}"?</p>
              <p class="text-danger">This action cannot be undone.</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-danger" @click="deleteDocument" :disabled="isDeleting">
                <span v-if="isDeleting" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Document Viewer Modal -->
      <div class="modal fade" id="documentViewerModal" tabindex="-1" aria-labelledby="documentViewerLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="documentViewerLabel">
                <i class="bx bx-file me-1"></i>
                {{ viewingDocument ? viewingDocument.name : 'Document Viewer' }}
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body p-0" style="min-height: 70vh;">
              <!-- Loading state -->
              <div v-if="isLoadingPreview" class="d-flex justify-content-center align-items-center h-100" style="min-height: 400px;">
                <div class="text-center">
                  <div class="spinner-border text-primary mb-3" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <p class="mb-0">Loading document preview...</p>
                </div>
              </div>

              <!-- Error state -->
              <div v-else-if="previewError" class="d-flex justify-content-center align-items-center h-100" style="min-height: 400px;">
                <div class="text-center text-danger">
                  <i class="bx bx-error-circle font-size-24 mb-2"></i>
                  <p class="mb-0">{{ previewError }}</p>
                  <button class="btn btn-sm btn-outline-primary mt-3" @click="downloadDocument(viewingDocument)">
                    <i class="bx bx-download me-1"></i> Download instead
                  </button>
                </div>
              </div>

              <!-- Document preview based on type -->
              <div v-else-if="viewingDocument" class="h-100">
                <!-- PDF Viewer -->
                <div v-if="viewingDocument.filePath && viewingDocument.filePath.toLowerCase().endsWith('.pdf')" class="h-100">
                  <div class="ratio ratio-16x9 h-100">
                    <iframe
                        :src="viewingDocument.previewUrl + '?embed=true'"
                        class="w-100 h-100 border-0"
                        allowfullscreen>
                    </iframe>
                  </div>
                </div>

                <!-- Image Viewer -->
                <div v-else-if="viewingDocument.filePath &&
                    (viewingDocument.filePath.toLowerCase().endsWith('.jpg') ||
                     viewingDocument.filePath.toLowerCase().endsWith('.jpeg') ||
                     viewingDocument.filePath.toLowerCase().endsWith('.png') ||
                     viewingDocument.filePath.toLowerCase().endsWith('.gif'))"
                     class="text-center p-3">
                  <img :src="viewingDocument.previewUrl" class="img-fluid" style="max-height: 70vh;" />
                </div>

                <!-- Text/HTML Viewer -->
                <div v-else-if="viewingDocument.filePath &&
                    (viewingDocument.filePath.toLowerCase().endsWith('.txt') ||
                     viewingDocument.filePath.toLowerCase().endsWith('.html') ||
                     viewingDocument.filePath.toLowerCase().endsWith('.htm'))"
                     class="h-100">
                  <div class="ratio ratio-16x9 h-100">
                    <iframe
                        :src="viewingDocument.previewUrl + '?embed=true'"
                        class="w-100 h-100 border-0">
                    </iframe>
                  </div>
                </div>

                <!-- Document Not Previewable -->
                <div v-else class="d-flex flex-column justify-content-center align-items-center h-100" style="min-height: 400px;">
                  <div class="text-center">
                    <div class="mb-4">
                      <i class="bx bx-file font-size-48 text-muted"></i>
                    </div>
                    <h5 class="mb-2">{{ viewingDocument.name }}</h5>
                    <p class="text-muted mb-3">
                      {{ getFileExtension(viewingDocument.filePath) ? getFileExtension(viewingDocument.filePath).toUpperCase() : 'Unknown' }} Document •
                      {{ viewingDocument.departmentName || 'General' }} •
                      Uploaded on {{ formatDate(viewingDocument.createdAt) }}
                    </p>
                    <p>This document type cannot be previewed directly in the browser.</p>
                    <div class="mt-3">
                      <button class="btn btn-primary" @click="downloadDocument(viewingDocument)">
                        <i class="bx bx-download me-1"></i> Download
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex justify-content-between w-100">
                <div>
                    <span class="badge bg-light text-dark me-2">
                      <i class="bx bx-show me-1"></i> {{ viewingDocument ? (viewingDocument.views || '0') : '0' }} views
                    </span>
                  <span class="badge" :class="{
                      'bg-success': viewingDocument && viewingDocument.category === 'Policy',
                      'bg-primary': viewingDocument && viewingDocument.category === 'Procedure',
                      'bg-info': viewingDocument && viewingDocument.category === 'Form',
                      'bg-warning': viewingDocument && viewingDocument.category === 'Report',
                      'bg-secondary': viewingDocument && viewingDocument.category === 'Manual',
                      'bg-dark': viewingDocument && (!viewingDocument.category || viewingDocument.category === 'Other')
                    }">
                      {{ viewingDocument ? (viewingDocument.category || 'Document') : 'Document' }}
                    </span>
                </div>
                <div>
                  <button style="margin-right: 5px" type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
                  <button  type="button" class="d-none btn btn-primary" @click="downloadDocument(viewingDocument)">
                    <i class="bx bx-download me-1"></i> Download
                  </button>
                  <button type="button" class="btn btn-success" @click="editDocument(viewingDocument)" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#editDocumentModal">
                    <i class="bx bx-edit me-1"></i> Edit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <footer class="footer ">
        <div class="container-fluid ">
          <div class="row ">
            <div class="col-sm-6 ">

            </div>
            <div class="col-sm-6 ">
              <div class="text-sm-end d-sm-block ">
                2024
              </div>
            </div>
          </div>
        </div>
      </footer>

    </div>
    <!-- end main content-->

  </div>
  <!-- END layout-wrapper -->

</template>

<script>
/* eslint-disable */
import {authUrl, execute, executeDownload, getRight, parking, trade} from "@/api";
import NavigationBar from "@/components/Navigation.vue";
import router from "@/router";
import moment from "moment";

export default {
  name: "DocumentsGeneral",
  components: {NavigationBar},
  data() {
    return {
      // Data state
      documents: [],
      departments: [],
      isLoading: false,
      isSubmitting: false,
      isDeleting: false,
      message: '',
      searchKeyword: '',
      selectedDepartment: '',
      selectedCategory: '', // Added new property for category filter
      statisticsEnabled: true,
      searchTimeout: null,

      // Bootstrap modals
      documentModal: null,
      editDocumentModal: null,
      deleteDocumentModal: null,
      documentViewerModal: null,

      // Document viewer
      viewingDocument: null,
      isLoadingPreview: false,
      previewError: null,

      // Form for adding a new document
      documentForm: {
        name: '',
        description: '',
        departmentId: '',
        category: '',
        file: null
      },

      // Form for editing a document
      editDocumentForm: {
        id: null,
        name: '',
        description: '',
        departmentId: '',
        category: '',
        file: null
      },

      // Delete document tracking
      deleteDocumentId: null,
      deleteDocumentName: '',

      // Statistics
      statistics: {
        totalDocuments: 0,
        recentUploads: 0,
        mostViewed: 0,
        categories: 0
      }
    };
  },
  mounted() {
    // Initialize data
    this.getDocuments(); // This will also update statistics from the response
    this.getDepartments();

    // Initialize modals - IMPORTANT: adding documentViewerModal initialization
    this.$nextTick(() => {
      this.documentModal = new bootstrap.Modal(document.getElementById('modal-document'));
      this.editDocumentModal = new bootstrap.Modal(document.getElementById('editDocumentModal'));
      this.deleteDocumentModal = new bootstrap.Modal(document.getElementById('deleteDocumentModal'));
      this.documentViewerModal = new bootstrap.Modal(document.getElementById('documentViewerModal'));
    });
  },
  methods: {
    // Add authUrl method
    authUrl() {
      return authUrl;
    },

    formatFileSize(bytes) {
      if (!bytes) return '0 Bytes';

      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    // Fetch documents from API
    getDocuments() {
      this.isLoading = true;
      const data = new FormData();
      data.append("function", "getDocuments");

      // Add filters if selected
      if (this.selectedDepartment) {
        data.append("department", this.selectedDepartment);
      }
      // Add category filter
      if (this.selectedCategory) {
        data.append("category", this.selectedCategory);
      }
      if (this.searchKeyword) {
        data.append("keyword", this.searchKeyword);
      }

      execute(data, authUrl)
          .then((res) => {
            this.isLoading = false;
            if (res.data.success) {
              if (res.data.data && Array.isArray(res.data.data.documents)) {
                // Process documents to add fileUrl for the View button
                this.documents = res.data.data.documents.map(doc => {
                  return {
                    ...doc,
                    // Create a full URL for viewing the document including authUrl
                    fileUrl: doc.filePath ? this.authUrl() + doc.filePath : '#',
                    uploadDate: doc.createdAt,
                    // Add the uploadedBy if available, otherwise set a default
                    uploadedBy: doc.uploadedBy || 'System Admin',
                    // Make sure department is displayed properly
                    department: doc.departmentName || 'General'
                  };
                });

                // Update statistics from the same response
                this.updateStatisticsFromResponse(res);
              } else {
                console.log("No documents found or incorrect data format");
                this.documents = [];
              }
            } else {
              this.message = res.data.message || "Failed to fetch documents";
              this.documents = [];
            }
          })
          .catch((e) => {
            this.isLoading = false;
            this.message = e.message || "An error occurred while fetching documents";
            this.documents = [];
          });
    },

    // Get departments list
    getDepartments() {
      const data = new FormData();
      data.append("function", "getDepartments");

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              if (res.data.data && Array.isArray(res.data.data.departments)) {
                this.departments = res.data.data.departments;
              } else {
                console.log("No departments data found or incorrect data format");
                this.departments = [];
              }
            } else {
              this.message = res.data.message || "Failed to fetch departments";
            }
          })
          .catch((e) => {
            this.message = e.message || "An error occurred while fetching departments";
          });
    },

    // Get document statistics from the documents API response
    updateStatisticsFromResponse(response) {
      if (response?.data?.data?.metrics) {
        const metrics = response.data.data.metrics;
        this.statistics = {
          totalDocuments: parseInt(metrics.totalDocuments) || 0,
          recentUploads: metrics.recentUploads?.length || 0,
          mostViewed: metrics.mostViewed?.length || 0,
          categories: metrics.categories?.length || 0
        };
      }
    },

    // Handle department selection change
    handleDepartmentChange() {
      this.getDocuments();
    },

    // Handle category selection change
    handleCategoryChange() {
      this.getDocuments();
    },

    // Handle search input
    handleSearch() {
      // Debounce search to avoid too many API calls
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = setTimeout(() => {
        this.getDocuments();
      }, 500);
    },

    // Handle file upload for add document form
    handleFileUpload(event) {
      this.documentForm.file = event.target.files[0];
    },

    // Handle file upload for edit document form
    handleEditFileUpload(event) {
      this.editDocumentForm.file = event.target.files[0];
    },

    // Submit new document
    submitDocument() {
      // Validate required fields
      if (!this.documentForm.name || !this.documentForm.file) {
        this.message = "Please fill all required fields";
        return;
      }

      this.isSubmitting = true;
      const data = new FormData();
      data.append("function", "addDocument");
      data.append("name", this.documentForm.name);
      data.append("description", this.documentForm.description || '');
      data.append("departmentId", this.documentForm.departmentId || '');
      data.append("category", this.documentForm.category || '');
      data.append("file", this.documentForm.file);

      execute(data, authUrl)
          .then((res) => {
            this.isSubmitting = false;
            if (res.data.success) {
              // Close modal and reset form
              if (this.documentModal) {
                this.documentModal.hide();
              }
              this.resetDocumentForm();

              // Show success message
              this.message = "Document added successfully";

              // Refresh documents list
              this.getDocuments(); // This will also update statistics
            } else {
              this.message = res.data.message || "Failed to add document";
            }
          })
          .catch((e) => {
            this.isSubmitting = false;
            this.message = e.message || "An error occurred while adding document";
          });
    },

    // Reset document form
    resetDocumentForm() {
      this.documentForm = {
        name: '',
        description: '',
        departmentId: '',
        category: '',
        file: null
      };

      // Reset file input
      const fileInput = document.getElementById('document-file');
      if (fileInput) fileInput.value = '';
    },

    // Open edit document modal
    editDocument(document) {
      this.editDocumentForm = {
        id: document.id,
        name: document.name,
        description: document.description || '',
        departmentId: document.departmentId || '',
        category: document.category || '',
        file: null,
        // Add current file path for reference
        currentFilePath: document.filePath || ''
      };

      // Reset file input
      const fileInput = document.getElementById('edit-document-file');
      if (fileInput) fileInput.value = '';
    },

    // Update document
    updateDocument() {
      if (!this.editDocumentForm.name) {
        this.message = "Document name is required";
        return;
      }

      this.isSubmitting = true;
      const data = new FormData();
      data.append("function", "updateDocument");
      data.append("id", this.editDocumentForm.id);
      data.append("name", this.editDocumentForm.name);
      data.append("description", this.editDocumentForm.description || '');
      data.append("departmentId", this.editDocumentForm.departmentId || '');
      data.append("category", this.editDocumentForm.category || '');
      data.append("currentFilePath", this.editDocumentForm.currentFilePath || '');

      // Only append file if a new one was selected
      if (this.editDocumentForm.file) {
        data.append("file", this.editDocumentForm.file);
        data.append("replaceFile", "1");
      } else {
        data.append("replaceFile", "0");
      }

      execute(data, authUrl)
          .then((res) => {
            this.isSubmitting = false;

            if (res.data.success) {
              // Close modal
              this.closeAllModals();
              // Show success message
              this.message = "Document updated successfully";

              // Refresh documents list
              this.getDocuments();
            } else {
              this.message = res.data.message || "Failed to update document";
            }
          })
          .catch((e) => {
            this.isSubmitting = false;
            this.message = e.message || "An error occurred while updating document";
          });
    },

    // Confirm document deletion
    confirmDeleteDocument(document) {
      this.deleteDocumentId = document.id;
      this.deleteDocumentName = document.name;

      if (this.deleteDocumentModal) {
        this.deleteDocumentModal.show();
      }
    },

    // Delete document
    deleteDocument() {
      if (!this.deleteDocumentId) return;

      this.isDeleting = true;
      const data = new FormData();
      data.append("function", "deleteDocument");
      data.append("id", this.deleteDocumentId);

      execute(data, authUrl)
          .then((res) => {
            this.isDeleting = false;
            if (res.data.success) {
              // Close modal
              if (this.deleteDocumentModal) {
                this.deleteDocumentModal.hide();
              }

              // Show success message
              this.message = "Document deleted successfully";

              // Refresh documents list
              this.getDocuments(); // This will also update statistics

              // Reset delete tracking
              this.deleteDocumentId = null;
              this.deleteDocumentName = '';
            } else {
              this.message = res.data.message || "Failed to delete document";
            }
          })
          .catch((e) => {
            this.isDeleting = false;
            this.message = e.message || "An error occurred while deleting document";
          });
    },

    // Export documents report
    exportReport(){
      const data = new FormData();
      data.append("function", "exportDocumentsReport");
      if (this.selectedDepartment) {
        data.append("department", this.selectedDepartment);
      }
      // Add category to export report
      if (this.selectedCategory) {
        data.append("category", this.selectedCategory);
      }
      executeDownload(data,authUrl).then(response => {
        this.message = "Report downloaded successfully";
        const link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download = "Documents_Report.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },

    // View document in-app
    viewDocument(document) {
      this.viewingDocument = document;
      this.isLoadingPreview = true;
      this.previewError = null;

      // Increment view count (this would be a separate API call)
      const data = new FormData();
      data.append("function", "incrementDocumentViews");
      data.append("id", document.id);

      execute(data, authUrl)
          .catch((e) => {
            console.error("Error tracking document view:", e);
          });

      // Show the modal right away while loading the document
      // IMPORTANT: Check if documentViewerModal is initialized before showing it
      if (!this.documentViewerModal) {
        // If documentViewerModal is not initialized, initialize it first
        this.documentViewerModal = new bootstrap.Modal(document.getElementById('documentViewerModal'));
      }

      // Now show the modal
      this.documentViewerModal.show();

      // In a real implementation, you might want to load the document contents
      setTimeout(() => {
        this.isLoadingPreview = false;

        // Get the actual file URL
        const filePath = document.filePath;
        if (!filePath) {
          this.previewError = "Document file not found";
          return;
        }

        // Create a copy of the document with the previewUrl property
        this.viewingDocument = {
          ...document,
          previewUrl: this.authUrl() + document.filePath
        };

        // Update the document with view information in the local state
        const docIndex = this.documents.findIndex(d => d.id === document.id);
        if (docIndex !== -1) {
          // Increment the view count locally
          this.documents[docIndex].views = (parseInt(this.documents[docIndex].views || 0) + 1).toString();

          // Also update the viewing document to show updated view count
          if (this.viewingDocument && this.viewingDocument.id === document.id) {
            this.viewingDocument.views = this.documents[docIndex].views;
          }
        }
      }, 800); // Simulate network delay
    },

    // Download document
    downloadDocument(document) {
      if (!document || !document.id) return;

      // Create a download link for the document with the full URL
      const downloadUrl = this.authUrl() + document.filePath;

      // Create a temporary link element and trigger the download
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', document.name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Optionally track the download with an API call
      const data = new FormData();
      data.append("function", "trackDocumentDownload");
      data.append("id", document.id);

      execute(data, authUrl)
          .catch((e) => {
            console.error("Error tracking document download:", e);
          });
    },

    // Get file extension from file path
    getFileExtension(filePath) {
      if (!filePath) return '';
      const parts = filePath.split('.');
      if (parts.length > 1) {
        return parts[parts.length - 1];
      }
      return '';
    },

    // Format date for display
    formatDate(dateString) {
      if (!dateString) return "--";
      return moment(dateString).format('DD MMM, YYYY');
    },

    // Close all modals
    closeAllModals() {
      // Close all modals using Bootstrap's API
      const modals = document.querySelectorAll('.modal.show');
      modals.forEach(modal => {
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) {
          modalInstance.hide();
        }
      });

      // Remove any lingering backdrop elements
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => {
        backdrop.remove();
      });

      // Fix the body by removing modal-open class and inline styles
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');
      document.body.style.removeProperty('overflow');
    }
  }
}
</script>